import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import mixpanel from "mixpanel-browser";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { CRUDActionEnum, StatusStateEnum, TopicFootprintTypeEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import moment from "moment";
import topicFootprintSelectors from "~/store/topicFootprints/selectors";
import topicFootprintSchema from "~/forms/TopicFootprintForm/topicFootprintSchema";
import TopicFootprintForm from "~/forms/TopicFootprintForm";
import topicFootprintActionCreators from "~/store/topicFootprints/actions";
import { helpers } from "~/lib/helpers";
const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
`;
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;

  .toolbar {
    position: sticky;
    top: -5px;
    z-index: 1;
  }
`;
const TopicFootprintUpdateModal = () => {
  const {
    t
  } = useTranslation();
  const footprint = useSelector(topicFootprintSelectors.getSelected);
  const footprintId = footprint?.id || "";
  const topicId = useSelector(topicFootprintSelectors.getSelectedData);
  const action = useSelector(topicFootprintSelectors.getAction);
  const status = useSelector(topicFootprintSelectors.getStatusByFootprint(footprintId));
  const error = useSelector(topicFootprintSelectors.getErrorByFootprint(footprintId));
  const dispatch = useDispatch();
  const defaultValues = {
    type: footprint?.type || TopicFootprintTypeEnum.TEXT,
    text: footprint?.data.text || "",
    files: footprint?.data.files || [],
    date: footprint?.date || moment().toISOString()
  };
  const {
    handleSubmit,
    control,
    reset
  } = useForm({
    resolver: yupResolver(topicFootprintSchema),
    defaultValues
  });
  useEffect(() => {
    if (action === CRUDActionEnum.UPDATE) {
      reset(defaultValues);
    }
  }, [action]);
  const onSubmit = handleSubmit(data => {
    dispatch(topicFootprintActionCreators.updateStarted(topicId, footprintId, data, _ref => {
      let {
        data: newTopic
      } = _ref;
      if (newTopic) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("TopicFootprintUpdateModal.footprintUpdated"),
          timeout: 10000
        }));
        reset(defaultValues);
      }
    }));
    mixpanel.track(`Topic Footprint Update – Save`, {
      ...helpers.objectDiff(defaultValues, data)
    });
  });
  const onCancel = () => {
    dispatch(topicFootprintActionCreators.actionChanged(null, null));
    mixpanel.track(`Topic Footprint Update – Cancel`);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("TopicFootprintUpdateModal.updateFootprint"),
    onClose: onCancel,
    fullWidth: true,
    maxWidth: "600px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Sticky, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error)), /*#__PURE__*/React.createElement(TopicFootprintForm, {
    control: control
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("TopicFootprintUpdateModal.saveFootprint")))));
};
export default TopicFootprintUpdateModal;